export function sortByRenderedLabel<T>(items: readonly T[], getRenderedLabel: (item: T) => string): T[] {
  return [...items].sort((leftItem, rightItem) =>
    getRenderedLabel(leftItem).localeCompare(getRenderedLabel(rightItem)),
  );
}
